import { Helmet } from "react-helmet";
import Navbar from "../components/universal/navbar";
import Header from "../components/complain-policy/hero";
import PP from "../components/complain-policy/content";
import CTA from "../components/universal/cta";
import Contact from "../components/universal/contact";
import Footer from "../components/universal/footer";

function Index() {
  return (
    <div>
      <Helmet>
        <title>Complaints Policy | Composite Bonding Ilkley Clinic</title>
        <link
          rel="canonical"
          href="https://www.compositebonding-ilkley.com/complain-policy"
        />
        <meta
          name="description"
          content="At Regent Dental, proudly serving Ilkley and Keighley, we value your satisfaction. See how our Complaints Policy ensures respectful and transparent care."
        />
      </Helmet>
      <Navbar />
      <Header />
      <PP />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
}

export default Index;
